import { WIZARD_PATHS } from './wizardRoutes';
import { nextIncompleteRoute, type WizardSessionData } from './wizardSteps';

// Mapt een sessie-state naar de wizard-route waar je hervat.
// Gedeeld door Dashboard-resume-banner en de ideeën-lijst "Ga verder".
export function resumeRouteForState(state: string): string {
  switch (state) {
    case 'idea_selection': return '/idea-select';
    case 'idea_approved': return '/article-direction';
    case 'article_generated': return '/article-edit';
    case 'article_approved': return '/title-generate';
    case 'image_selected': return '/blog-preview';
    default: return '/article-direction';
  }
}

// Hervat-route op basis van de hele sessierij: kijkt naar de data, niet alleen
// naar de status-enum (die 'article_generated' nooit krijgt en tussen titel en
// beeld niet opschuift).
export function resumeRouteForSession(session: WizardSessionData & { state?: string | null }): string {
  const state = session.state ?? '';
  if (state === 'idea_selection') return WIZARD_PATHS.ideaSelect;
  if (session.article_content) {
    if (state === 'idea_approved' || state === 'article_generated') return WIZARD_PATHS.articleEdit;
    return nextIncompleteRoute(session);
  }
  return resumeRouteForState(state);
}
